<template>
  <div>
    <v-text-field
      variant="solo"
      flat
      hide-details=""
      label="Add a website link"
      placeholder="www.example.com"
      v-model="link"
      :loading="link_loading"
      @keyup.enter="enter"
    >
      <template #append-inner>
        <v-btn
          v-if="link"
          :loading="link_loading"
          @click="enter"
          icon="mdi-plus"
          size="small"
          elevation="0"
          variant="text"
        ></v-btn>
      </template>
    </v-text-field>
  </div>
</template>

<script>
import { httpsCallable } from "firebase/functions";
import { functions } from "@/firebase";
import { languages } from "@/mixins/languages";

export default {
  props: ["sheet", "link_preview", "media"],
  mixins: [languages],
  data() {
    return {
      instructions: "",
      menu: false,
      link: "",
      link_step: 0,
      link_loading: false,
      preview_loading: false,
      write_post: false,
    };
  },
  methods: {
    next() {
      if (this.link_step === 0 && this.write_post) {
        console.log(1);
        this.link_step = 1;
      } else {
        console.log(2);
        this.getPreview();
      }
    },
    enter(v) {
      if (v.code === "Enter") {
        this.next();
      }
    },
    async getPreview() {
      this.link_loading = true;
      let prefix = "https://";
      let link = this.link;
      console.log(link);
      this.link_step = 2;
      if (this.link != "") {
        if (!link.includes("http")) {
          link = prefix.concat(this.link);
        }
        this.preview_loading = true;
        console.log("Getting link preview");
        const getPreview = httpsCallable(functions, "getLinkPreview");
        const res = await getPreview({
          url: link,
        });
        console.log(res.data);
        if (res.data.error) {
          this.$store.commit("setNotification", {
            show: true,
            text: "Something went wrong. Try another URL.",
            type: "error",
            icon: "",
          });
        } else {
          let result = res.data;
          result.write_post = this.write_post;
          result.instructions = this.instructions;
          this.$emit("preview", result);
          this.menu = false;
        }

        this.preview_loading = false;
        this.link = "";
        this.link_step = 0;
        this.write_post = false;
        this.link_loading = false;
      } else {
        this.link_loading = false;
        this.$store.commit("setNotification", {
          show: true,
          text: "Incorrect link",
          type: "error",
          icon: "",
        });
        this.link_loading = false;
      }
    },
    success() {
      this.link_step = 1;
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .v-dialog {
  border-radius: 10px;
}

:deep(.v-text-field input) {
  font-size: 10pt;
}

.linkone {
  height: 175px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
</style>
